/* Odd World Studio: wall calendar product page.
   Pages flip up like a hanging calendar as you scroll through the pinned stage. */
(function () {
  function init() {
    var root = document.querySelector('[data-owc]');
    if (!root) return;
    var year = parseInt(root.getAttribute('data-year'), 10) || new Date().getFullYear();

    /* ---------- Month day grids ---------- */
    root.querySelectorAll('[data-owc-sheet][data-month]').forEach(function (sheet) {
      var m = parseInt(sheet.getAttribute('data-month'), 10);
      var box = sheet.querySelector('[data-owc-days]');
      if (!box) return;
      var html = '';
      ['S', 'M', 'T', 'W', 'T', 'F', 'S'].forEach(function (d, i) {
        html += '<b class="' + (i === 0 || i === 6 ? 'we' : '') + '">' + d + '</b>';
      });
      var first = new Date(year, m, 1).getDay();
      var days = new Date(year, m + 1, 0).getDate();
      for (var i = 0; i < first; i++) html += '<span></span>';
      for (var d = 1; d <= days; d++) {
        var wd = (first + d - 1) % 7;
        html += '<span class="' + (wd === 0 || wd === 6 ? 'we' : '') + '">' + d + '</span>';
      }
      box.innerHTML = html;
    });

    /* ---------- Buy form helpers ---------- */
    root.querySelectorAll('[data-owc-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-owc-step'), 10));
        input.value = v;
      });
    });
    // two buy forms (beside the calendar + in the details card): keep their variant + price in sync
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-owc-variant]'));
    var prices = Array.prototype.slice.call(root.querySelectorAll('[data-owc-price]'));
    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        selects.forEach(function (other) { if (other !== sel) other.value = sel.value; });
        var o = sel.options[sel.selectedIndex];
        var p = o && o.getAttribute('data-price');
        if (p) prices.forEach(function (el) { el.textContent = p; });
      });
    });

    /* ---------- Flip on scroll ---------- */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stage = root.querySelector('.owc-stage');
    var sheets = Array.prototype.slice.call(root.querySelectorAll('[data-owc-sheet]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-owc-dot]'));
    var label = root.querySelector('[data-owc-label]');
    var bar = root.querySelector('.owc-progress i');
    var hint = root.querySelector('[data-owc-hint]');
    var hintText = root.querySelector('[data-owc-hint-text]');
    var n = sheets.length;
    if (reduce || n < 2 || !stage) { root.classList.add('owc-still'); return; }
    root.classList.add('owc-live');

    // instruction text: "Swipe up" on touch screens, "Scroll" with a mouse/trackpad
    var touch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    var startMsg = (hintText && hintText.textContent.trim()) || 'Scroll to flip through the calendar';
    if (touch) startMsg = startMsg.replace(/^scroll/i, 'Swipe up');
    var keepVerb = touch ? 'Keep swiping' : 'Keep scrolling';
    var endMsg = (touch ? 'Swipe up' : 'Scroll') + ' for details';
    var hintShown = '';
    function setHint(msg, state) {
      if (!hintText || msg === hintShown) return;
      hintShown = msg;
      hintText.textContent = msg;
      if (hint) hint.setAttribute('data-state', state);
    }

    // one screen of scrolling per page turn, plus a beat at the start and end
    function size() { stage.style.height = ((n - 1) * 70 + 150) + 'vh'; }
    size();

    var shown = -1, ticking = false;
    function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function frame() {
      ticking = false;
      var r = stage.getBoundingClientRect();
      var total = Math.max(1, stage.offsetHeight - window.innerHeight);
      var p = Math.min(1, Math.max(0, (-r.top) / total));
      // spread the n-1 flips across 10%..92% of the pinned scroll
      var t = Math.min(1, Math.max(0, (p - 0.1) / 0.82)) * (n - 1);
      var top = Math.min(n - 1, Math.floor(t + 0.5));
      sheets.forEach(function (s, k) {
        var f = Math.min(1, Math.max(0, t - k));   // 0 = hanging, 1 = flipped over
        var e = ease(f);
        s.style.setProperty('--f', e.toFixed(4));
        s.style.transform = 'perspective(2200px) rotateX(' + (e * 172).toFixed(2) + 'deg)';
        s.style.zIndex = f >= 0.5 ? String(k) : String(100 + n - k);
        s.classList.toggle('is-over', f >= 0.5);
        s.classList.toggle('is-lit', k === top || (f > 0 && f < 1));
      });
      if (top !== shown) {
        shown = top;
        if (label) label.textContent = sheets[top].getAttribute('data-label') || '';
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === top); d.classList.toggle('is-past', i < top); });
      }
      if (t < 0.02) setHint(startMsg, 'start');
      else if (t > n - 1.02) setHint(endMsg, 'end');
      else setHint(keepVerb + ' · page ' + (top + 1) + ' of ' + n, 'mid');

      root.style.setProperty('--p', p.toFixed(4));
      if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { size(); onScroll(); });
    frame();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
